import script from "./TechnicalPropertyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalPropertyInfo.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalPropertyInfo.vue?vue&type=style&index=0&id=1a8e8821&lang=less&scoped=true"

import exportComponent from "/builds/sun-chemical/color-materials/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8e8821"]])

export default __exports__